import React from "react";
import { HUNDRED, ONE_DECIMAL, TWO_DECIMAL, UNDEFINED, ZERO } from "../../App";
import { BenchmarkData, Publication } from "../types/dataTypes";

const getAllPagesPercentages = (publications: Publication[]): any => {
	const totalAmountOfPublications = publications.length;
	let result: number = UNDEFINED;
	let percentage: number = UNDEFINED;

	publications.forEach(publication => {
		percentage = ((publication.data.averagePageViewPerSession /
			publication.data.totalPages) * HUNDRED);
		if (isNaN(percentage)) percentage = ZERO;
		result = result + percentage;
	});
	result = Math.round((result / totalAmountOfPublications) * ONE_DECIMAL) / ONE_DECIMAL;
	return result;
};

export const setBenchmarkCriteriaAverages = (publications: Publication[]): BenchmarkData => {
	const totalAmountOfPublications = publications.length;

	const avgPagesPerVisit = getAllPagesPercentages(publications);

	const avgUniqueVisitors = ((publications.reduce((sum, current) =>
		sum + current.data.uniqueVisitors, UNDEFINED)) /
		totalAmountOfPublications);

	const avgDocVisits = ((publications.reduce((sum, current) =>
		sum + current.data.docVisits, UNDEFINED)) /
		totalAmountOfPublications);

	const avgVisitTime = Math.round(((publications.reduce((sum, current) =>
		sum + current.data.averageSessionDuration, UNDEFINED)) /
		totalAmountOfPublications) * TWO_DECIMAL) / TWO_DECIMAL;

	const benchmarkCriteria: BenchmarkData = {
		avgUniqueVisitors: avgUniqueVisitors,
		avgDocVisits: avgDocVisits,
		avgVisitTime: avgVisitTime,
		avgPagesPerVisit: avgPagesPerVisit
	};

	return benchmarkCriteria;
};